import { render, staticRenderFns } from "./Deep.vue?vue&type=template&id=c6c2848c&scoped=true&"
import script from "./Deep.vue?vue&type=script&lang=js&"
export * from "./Deep.vue?vue&type=script&lang=js&"
import style0 from "./Deep.vue?vue&type=style&index=0&id=c6c2848c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c2848c",
  null
  
)

export default component.exports